// HUD: очки с тикером, метры, этажи, жизни-домики, комбо, PERFECT,
// индикатор ветра, анонс уровня, оверлеи с двумя кнопками.
// Чистый DOM без фреймворков — быстрее и легче для Mini App.
import { sfx } from './audio.mjs';

const el = (id) => document.getElementById(id);

// Красный домик Этажи (жизнь) — инлайн-SVG
const HOUSE_SVG = `<svg class="life" viewBox="0 0 26 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M13 1 L25 11 H21 V23 H5 V11 H1 Z" fill="#E2231A" stroke="#fff" stroke-width="1.6" stroke-linejoin="round"/>
  <rect x="10" y="15" width="6" height="8" fill="#fff"/>
</svg>`;

export function createHud(hooks = {}) {
  let scoreTarget = 0;
  let scoreShown = 0;
  let prevLives = 99;
  let overlayOpen = false;
  let onBtnAction = null;
  let onBtn2Action = null;
  let onClaimAction = null;
  let onShareAction = null;
  let onMapAction = null;

  el('ov-btn').addEventListener('click', () => { if (onBtnAction) onBtnAction(); });
  el('ov-btn2').addEventListener('click', () => { if (onBtn2Action) onBtn2Action(); });
  el('ov-share').addEventListener('click', () => { if (onShareAction) onShareAction(); });
  el('ov-map').addEventListener('click', () => { if (onMapAction) onMapAction(); });

  // Забрать подарок: кнопка → промокод на карточке + отметка об отправке в личку
  el('ov-gift-btn').addEventListener('click', async () => {
    if (!onClaimAction) return;
    const btn = el('ov-gift-btn');
    btn.disabled = true;
    btn.textContent = 'Секунду…';
    try {
      const r = await onClaimAction();
      btn.style.display = 'none';
      el('ov-code').textContent = r.code;
      el('ov-code').style.display = 'block';
      el('ov-code-note').textContent = r.sent
        ? 'Промокод отправлен ботом тебе в личку ✓'
        : (r.repeat ? 'Этот приз ты уже забирал — код тот же.' : 'Сохрани код: покажи его менеджеру Этажей.');
      el('ov-code-note').style.display = 'block';
      renderFeatured(); // мостик воронки: приз получен → подборка объектов
    } catch (e) {
      btn.disabled = false;
      btn.textContent = '🎁 Получить подарок';
      el('ov-code-note').textContent = 'Не получилось связаться с сервером — попробуй ещё раз.';
      el('ov-code-note').style.display = 'block';
    }
  });

  // «Подобрали для тебя»: карточки объектов после вручения приза.
  // Тап «Хочу посмотреть» помечает лид заинтересованным на сервере.
  async function renderFeatured() {
    if (!hooks.loadFeatured) return;
    const box = el('ov-featured');
    if (!box) return;
    let objects = [];
    try { objects = await hooks.loadFeatured(); } catch (e) { /* подборка не критична */ }
    if (!objects.length) return;

    box.innerHTML = '<div id="ov-featured-title">🏝 Подобрали для тебя</div>';
    for (const o of objects) {
      const row = document.createElement('div');
      row.className = 'feat-row';
      // Фото с фолбэком: нет картинки — плитка с первой буквой района
      const pic = document.createElement('div');
      pic.className = 'feat-pic';
      pic.textContent = (o.district || '?')[0];
      if (o.photo) {
        const img = document.createElement('img');
        img.alt = '';
        img.onload = () => { pic.textContent = ''; pic.appendChild(img); };
        img.src = o.photo;
      }
      const info = document.createElement('div');
      info.className = 'feat-info';
      const price = document.createElement('b');
      price.textContent = `${o.district} · ${o.price}`;
      const title = document.createElement('div');
      title.textContent = o.title;
      const line = document.createElement('small');
      line.textContent = o.line || '';
      info.append(price, title, line);

      const btn = document.createElement('button');
      btn.className = 'feat-btn';
      btn.textContent = 'Хочу посмотреть';
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        btn.textContent = 'Секунду…';
        try {
          await hooks.onInterest(o.id);
          box.querySelectorAll('.feat-btn').forEach((b) => { b.disabled = true; });
          btn.textContent = '🤝 Агент свяжется';
        } catch (e) {
          btn.disabled = false;
          btn.textContent = 'Хочу посмотреть';
        }
      });

      row.append(pic, info, btn);
      box.appendChild(row);
    }
    box.style.display = 'block';
  }

  return {
    setScore(v) {
      // Крупное начисление (перфект, золотой этаж) отбивается пульсом счётчика
      if (v - scoreTarget >= 140) {
        const node = el('score-value');
        node.classList.remove('pop');
        void node.offsetWidth;
        node.classList.add('pop');
      }
      scoreTarget = v;
    },

    setMeters(m) { el('meters-chip').textContent = `${m} м`; },

    setFloors(cur, total) { el('floors-chip').textContent = `${cur} / ${total}`; },

    setLives(cur, max) {
      const box = el('lives-box');
      if (box.children.length !== max) {
        box.innerHTML = HOUSE_SVG.repeat(max);
        prevLives = cur;
      }
      [...box.children].forEach((h, i) => h.classList.toggle('lost', i >= cur));
      // Потеря жизни должна быть заметна: гаснущий домик дёргается
      if (cur < prevLives) {
        const lost = box.children[cur];
        if (lost) {
          lost.classList.remove('shake');
          void lost.offsetWidth;   // перезапуск анимации
          lost.classList.add('shake');
        }
      }
      prevLives = cur;
    },

    combo(n, multiplied) {
      const pill = el('combo-pill');
      if (n >= 2) {
        el('combo-n').textContent = `×${n}`;
        el('combo-mult').style.display = multiplied ? 'block' : 'none';
        pill.classList.add('show');
      } else {
        pill.classList.remove('show');
      }
    },

    // Индикатор ветра: strength ∈ [-1..1], знак — направление
    setWind(strength, active) {
      const box = el('wind-ind');
      box.classList.toggle('show', !!active);
      if (!active) return;
      const pct = Math.min(100, Math.abs(strength) * 100);
      el('wind-fill').style.width = `${pct}%`;
      el('wind-fill').classList.toggle('strong', pct > 65);
      el('wind-arrow').textContent = strength >= 0 ? '→' : '←';
    },

    perfectPop(text = 'PERFECT!') {
      const pop = el('perfect-pop');
      pop.textContent = text;
      pop.classList.remove('pop');
      void pop.offsetWidth; // перезапуск CSS-анимации
      pop.classList.add('pop');
    },

    // Анонс уровня при старте: название + подзаголовок
    announce(title, sub) {
      el('announce-title').textContent = title;
      el('announce-sub').textContent = sub || '';
      const a = el('announce');
      a.classList.remove('show');
      void a.offsetWidth;
      a.classList.add('show');
    },

    flashRed() {
      const f = el('red-flash');
      f.classList.add('on');
      setTimeout(() => f.classList.remove('on'), 120);
    },

    hint(visible) { el('tap-hint').classList.toggle('hidden', !visible); },

    authChip(text) { el('auth-chip').textContent = text; },

    get isOverlayOpen() { return overlayOpen; },

    showOverlay({ mood, ribbon, title, sub, stats, btnText, onBtn, btn2Text, onBtn2, gift, onClaim, onShare, onMap, onPhoto = null, stars = null, pulseBtn = false }) {
      overlayOpen = true;
      onBtnAction = onBtn || null;
      onBtn2Action = onBtn2 || null;
      onClaimAction = onClaim || null;
      onShareAction = onShare || null;
      onMapAction = onMap || null;
      el('ov-card').classList.toggle('lose', mood === 'lose');
      el('ov-ribbon').textContent = ribbon;
      el('ov-title').textContent = title;
      el('ov-sub').textContent = sub || '';
      el('ov-stats').innerHTML = (stats || [])
        .map((s) => `<div class="stat"><div class="v">${s.value}</div><div class="l">${s.label}</div></div>`)
        .join('');

      // Подарочная карточка (только на победе и если приз предусмотрен)
      const giftBox = el('ov-gift');
      if (gift) {
        giftBox.style.display = 'block';
        el('ov-gift-title').textContent = `🎁 Подарок от Этажей: ${gift.title}`;
        const btn = el('ov-gift-btn');
        btn.style.display = 'block';
        btn.disabled = false;
        btn.textContent = gift.claimed ? 'Показать мой промокод' : '🎁 Получить подарок';
        el('ov-code').style.display = 'none';
        el('ov-code-note').style.display = 'none';
      } else {
        giftBox.style.display = 'none';
      }
      // Подборка объектов показывается заново только после клейма приза
      const featBox = el('ov-featured');
      if (featBox) { featBox.style.display = 'none'; featBox.innerHTML = ''; }

      // Звёзды забега (посчитал сервер): зажигание по одной с растущим дзынем
      const starsBox = el('ov-stars');
      starsBox.innerHTML = '';
      starsBox.style.display = stars != null ? 'flex' : 'none';
      if (stars != null) {
        for (let i = 0; i < 3; i++) {
          const s = document.createElement('span');
          s.className = 'ov-star';
          s.textContent = '★';
          starsBox.appendChild(s);
          if (i < stars) {
            setTimeout(() => {
              if (!overlayOpen) return;
              s.classList.add('lit');
              sfx.perfect(i * 3); // питч-лестница сэмпла — звёзды «поют» вверх
            }, 500 + i * 450);
          }
        }
      }

      // Фото-режим: только на победе (красивое здание уже стоит)
      const photoBtn = el('ov-photo');
      photoBtn.style.display = onPhoto ? 'block' : 'none';
      photoBtn.onclick = onPhoto || null;

      el('ov-btn').classList.toggle('pulse', pulseBtn);
      el('ov-btn').textContent = btnText || 'Ещё раз';
      el('ov-actions').style.display = (onShare || onMap) ? 'flex' : 'none';
      el('ov-share').style.display = onShare ? 'block' : 'none';
      el('ov-map').style.display = onMap ? 'block' : 'none';
      el('ov-btn2').style.display = btn2Text ? 'block' : 'none';
      el('ov-btn2').textContent = btn2Text || '';
      el('overlay').classList.remove('hidden');
    },

    hideOverlay() {
      overlayOpen = false;
      el('overlay').classList.add('hidden');
    },

    // Фото-режим: HUD и оверлеи прячутся, остаётся панель снимка
    setPhotoMode(on) {
      document.body.classList.toggle('photo-mode', on);
      el('photo-ui').classList.toggle('hidden', !on);
      el('photo-hint').classList.toggle('hidden', !on);
    },

    // Тикер очков: цифры «догоняют» значение — counter-up из ТЗ
    update(dt) {
      if (scoreShown !== scoreTarget) {
        scoreShown += (scoreTarget - scoreShown) * Math.min(1, dt * 8);
        if (Math.abs(scoreTarget - scoreShown) < 1) scoreShown = scoreTarget;
        el('score-value').textContent = Math.round(scoreShown).toLocaleString('ru-RU');
      }
    },

    resetScoreInstant() {
      scoreShown = 0;
      scoreTarget = 0;
      el('score-value').textContent = '0';
    },
  };
}
